import React from "react";
import {
  Button,
  Form,
  Grid,
} from "semantic-ui-react";
import { loginAction } from "../actions/index";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { isLoggedIn } from "../util";
import { withRouter } from "react-router";
import { toast, SemanticToastContainer } from "react-semantic-toasts";
import matrix from "../Images/matrix-logo.png";
import "../styles/index.css";
import { Modal, Box, Typography } from "@mui/material";
import OtpInput from 'react-otp-input';
import {sendVerificationCode,verifyVerificationCode} from "../actions/users_action"

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      email: false,
      emailId: ""
    };
  }

  handleUsernameChange = (e) => {
    this.setState({ username: e.target.value });
  };

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
  };

  authenticate = () => {
    this.props.login(
      this.state.username,
      this.state.password,
      {
        onSuccess:(res)=>{
          if(res.status == 200){
            this.setState({modalopen:true})
            let data = {
              emailId:res.data.email,
              userName:this.state.username              
            }
            this.setState({emailId:res.data.email})
            this.props.sendVerificationCode(data,{
              onSuccess:()=>{
                  alert('Otp Sent to Register EmailId')
              },
              onFailure:()=>{

              }
            })
          }
        },
        onFailure:()=>{
            alert('UserName or Password is InCorrect. Please Check')
        }
      }
    );
  };

  email = () => {
    this.setState({
      email: true,
    });
  };

  Close = () => {
    this.setState({
      email: false,
    });
  };

  handleClose = () =>{
    this.setState({modalopen:false})
  }
  handleOTP = (data)=>{
    this.setState({code:data})
  }

  verifyCode = () =>{
    let data = {
      emailId:this.state.emailId,
      verification_code:this.state.code,
      userName:this.state.username
    }
    this.props.verifyVerificationCode(data,{
      onSuccess:()=>{
        if(this.props.auth.userName === 'HFSTeam' ){
          this.props.history.push("/controlpanel");
        }
        else{
          this.props.history.push("/home");
        }
        
      },
      onFailure:()=>{
        alert('OTP not match. Please enter correct one.')
      }
    })
  }

  render() {
    var loginBoxStyle = {
      borderRadius: 6,
      WebkitBoxShadow: "10px 11px 81px 3px rgba(191,191,191,1)",
      MozBoxShadow: "10px 11px 81px 3px rgba(191,191,191,1)",
      boxShadow: "10px 11px 81px 3px rgba(191,191,191,1)",
    };

    return (
      <div>
      <Grid
        textAlign="center"
        style={{ height: "100vh" }}
        verticalAlign="middle"
      >
        <Grid.Column style={{ maxWidth: 500, borderRadius: "15px" }}>
          <img src={matrix} style={{ height: "100px", width: "180px" }} />
          <Form className="auth-inner">
            {/* <img src={matrix} /> */}
            <Form.Input
              fluid
              icon="user"
              iconPosition="left"
              placeholder="E-mail address"
              onChange={this.handleUsernameChange}
            />
            <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              placeholder="Password"
              type="password"
              onChange={this.handlePasswordChange}
            />

            <Button color="blue" fluid size="large" onClick={this.authenticate}>
              Login
            </Button>
          </Form>
        </Grid.Column>
      </Grid>
          <Modal
          open={this.state.modalopen}
          onClose={this.handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 500,
            height: 200,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}>
            <Typography id="modal-modal-title" variant="h6" component="h2" color={'#2185d0'}>
              Enter Your OTP:
            </Typography>
            <OtpInput
              value={this.state.code}
              style={{}}
              onChange={this.handleOTP}
              numInputs={4}
              separator={<span><span><span>-</span></span></span>}
              containerStyle={{ marginRight: 40, width: 50 }}
              inputStyle={{ width: 80, height: 50 }}
            />
            <Button
              variant="contained"
              size="small"
              onClick={this.handleClose}
              style={{ display: 'flex', marginTop: 40, float: 'right', marginLeft: 20,color:'white',backgroundColor:'red' }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={this.verifyCode}
              style={{ display: 'flex', marginTop: 40, float: 'right',color:'white',backgroundColor:'green' }}
            >
              Verify
            </Button>
          </Box>
        </Modal>  
        </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      login: loginAction,
      sendVerificationCode,
      verifyVerificationCode
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
